export default __webpack_public_path__ + "static/media/SquaresIcon.5cbc2eb2.svg";